import { msg } from '@lingui/core/macro';

export const MY_IMPORTED_LEARNINGS_DATA_INDEX = {
    EMPLOYEE_ID: 'employeeId',
    SOURCE_SYSTEM: 'sourceSystem',
    SOURCE_USER_ID: 'sourceUserId',
    TYPE: 'type',
    TITLE: 'title',
    COMPLETED_DATE: 'completedDateUTC',
    SOURCE_RANK: 'sourceRank',
    REQUIRED: 'isRequired',
    COMPLETION: 'completionPercent',
    SCORE: 'score',
    LEARNING_TIME: 'learningTimeMinutes',
    IMPORTED_ON: 'importedOnUTC',
    IMPORTED_BY: 'importedBy',
} as const;

export const MY_IMPORTED_LEARNINGS_COLUMN_TITLE = {
    EMPLOYEE_ID: msg`Employee ID`,
    SOURCE_SYSTEM: msg`Source System`,
    SOURCE_USER_ID: msg`Source User ID`,
    TYPE: msg`Type`,
    TITLE: msg`Title`,
    COMPLETED_DATE: msg`Completed Date`,
    SOURCE_RANK: msg`Source Rank`,
    REQUIRED: msg`Required`,
    COMPLETION: msg`Completion %`,
    SCORE: msg`Score`,
    LEARNING_TIME: msg`Learning Time`,
    IMPORTED_ON: msg`Imported On`,
    IMPORTED_BY: msg`Imported By`,
} as const;

// Imported learnings request filter and sort keys (mock for now).
// Assumption: same PascalCase style as the `users/results/learnings` request.
export const IMPORTED_LEARNINGS_REQUEST_KEY = {
    EMPLOYEE_ID: 'EmployeeId',
    SOURCE_SYSTEM: 'SourceSystem',
    SOURCE_USER_ID: 'SourceUserId',
    TYPE: 'Type',
    SOURCE_RANK: 'SourceRank',
    IS_REQUIRED: 'IsRequired',
    COMPLETED_DATE: 'CompletedDateUTC',
    IMPORTED_ON: 'ImportedOn',
    IMPORTED_BY: 'ImportedBy',
} as const;
export const MY_IMPORTED_LEARNINGS_COLUMN_FILTER_REQUEST_MAP: Record<string, string> = {
    [MY_IMPORTED_LEARNINGS_DATA_INDEX.EMPLOYEE_ID]: IMPORTED_LEARNINGS_REQUEST_KEY.EMPLOYEE_ID,
    [MY_IMPORTED_LEARNINGS_DATA_INDEX.SOURCE_SYSTEM]: IMPORTED_LEARNINGS_REQUEST_KEY.SOURCE_SYSTEM,
    [MY_IMPORTED_LEARNINGS_DATA_INDEX.SOURCE_USER_ID]: IMPORTED_LEARNINGS_REQUEST_KEY.SOURCE_USER_ID,
    [MY_IMPORTED_LEARNINGS_DATA_INDEX.TYPE]: IMPORTED_LEARNINGS_REQUEST_KEY.TYPE,
    [MY_IMPORTED_LEARNINGS_DATA_INDEX.SOURCE_RANK]: IMPORTED_LEARNINGS_REQUEST_KEY.SOURCE_RANK,
    [MY_IMPORTED_LEARNINGS_DATA_INDEX.REQUIRED]: IMPORTED_LEARNINGS_REQUEST_KEY.IS_REQUIRED,
    [MY_IMPORTED_LEARNINGS_DATA_INDEX.IMPORTED_ON]: IMPORTED_LEARNINGS_REQUEST_KEY.IMPORTED_ON,
    [MY_IMPORTED_LEARNINGS_DATA_INDEX.IMPORTED_BY]: IMPORTED_LEARNINGS_REQUEST_KEY.IMPORTED_BY,
};
